/**
 * @module websocket.event.handlers.passengers.passenger-list-updated
 */
import { store } from '../../../../state/store'
import { setPassengerListUpdated } from '../../../../state/websocket.slice'

export default function handlePassengerListUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  if (isSubscribed) {
    store.dispatch(setPassengerListUpdated(data))
  }
}
